import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import Home from "./components/Home";
import Layout from "./components/common/Layout";
import WorkOutIndex from "./components/WorkoutIndex";
import WorkoutList from "./components/WorkoutList";
import Login from "./components/Login";
import SignUp from "./components/Signup";
import ShowExercise from "./components/ShowWorkout";

function App() {
  //Adding general states on the parent component to pass it to all other components.
  const [partOfBody, SetPartOfBody] = React.useState(undefined);
  const [newWorkOut, StartNewWorkOut] = React.useState(undefined);
  const [muscleTarget, setMuscleTarget] = React.useState(undefined);

  async function fetchWorkoutList() {
    const resp = await fetch(`https://exercisedb.p.rapidapi.com/exercises`, {
      method: "GET",
      headers: {
        "x-rapidapi-host": process.env.REACT_APP_APIHOST,
        "x-rapidapi-key": process.env.REACT_APP_APIKEY,
      },
    });
    const data = await resp.json();

    StartNewWorkOut(data);
  }
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/getstarted"
            element={
              <WorkOutIndex
                handleStartWorkOut={StartNewWorkOut}
                getData={fetchWorkoutList}
                newWorkOut={newWorkOut}
              />
            }
          />
          <Route
            path="/exercises"
            element={
              <WorkoutList
                handleSelectBodyPart={SetPartOfBody}
                handleStartWorkOut={StartNewWorkOut}
                updateMuscleTarget={setMuscleTarget}
                getData={fetchWorkoutList}
                newWorkOut={newWorkOut}
                partOfBody={partOfBody}
                muscleTarget={muscleTarget}
              />
            }
          />
          <Route
            path="/exercises/exercise/:exerciseId"
            element={<ShowExercise />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
